/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { useEffect, useRef, useState } from "react";
import {
  ProfileDetails,
  clearNotification,
  listOrdersData,
  searching,
  deleteNotificationToken,
  settingsDetails,
} from "../auth/core/_requests";
import { toast } from "react-toastify";
import HeaderMenu from "./HeaderMenu";
import Sidebar from "./SideBar";
import NotificationModal from "./NotificationModal";
import OrderModal from "./OrderModal";
import { useChef } from "../component/chef-context/chefContext";
import { OrderProps } from "../modules/orders/core/_models";
import socket from "../component/socket";
import { listTiming } from "../modules/settings/core/_requests";
import { normalizeWorkingHours } from "../timingConfig";
import { useWorkingHours } from "../component/context/WorkingHoursContext";
import { useChefAutoOffline } from "../component/context/useChefAutoOfflineOnline";
import { formatToAMPM } from "../component/dateUtils";
type NotificationData = {
  id: string;
  title: string;
  description: string;
  name: string;
  time: string;
};

const Header = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const {
    setOrderId,
    orders,
    setOrders,
    chefStatus,
    setChefStatus,
    showOrderModal,
    setShowOrderModal,
    setIsLoggedIn,
  } = useChef();
  
  const [notification, setNotification] = useState<NotificationData[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  type SettingsType = {
    opening_time?: any;
    closing_time?: any;
    // add other properties as needed
  };

  const [settings, setSettings] = useState<SettingsType>({});
  const [showModal, setShowModel] = useState(false);

  const chefId = currentUser?.uuid;
  const [menuMobileActive, setMenuMobileActive] = useState(false); // State for menu-mobile
  const { manualToggle, setManualToggle } = useWorkingHours();
  const [msgsound, setnotificationSound] = useState<any>();
  const [profiledata, setProfileData] = useState<any>();
  const [getIsCoupon, setIsCoupon] = useState<any>();
  const [getIsReport, setIsReport] = useState<any>();
  const [planName, setIsPlanName] = useState<any>();
  const [mainSearch, setMainSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [isVideoVisible, setVideoVisible] = useState(false);
// AUDIO FIX — useRef ensures immediate stop, no async delay
const audioRef = useRef<HTMLAudioElement | null>(null);
const soundTimeoutsRef = useRef<number[]>([]);


  const handleIconClick = () => {
    setVideoVisible(!isVideoVisible);
  };

  useChefAutoOffline(chefId);

  const logoutFunction = async () => {
    const notificationToken = localStorage.getItem("fcmToken");
    // Ensure both notificationToken and chefId are valid
    if (notificationToken && chefId) {
      const data = { notificationToken, chefId };

      try {
        // Call the API to remove the notification token
        const removeNotificationToken = await deleteNotificationToken(data);

        // Check if the token was successfully removed
        if (removeNotificationToken.status == true) {
          // Redirect to login page and refresh the window
          navigate("/login");
          localStorage.clear();
          setIsLoggedIn(false);
          window.location.reload();
        } else {
        }
      } catch (error) {
        console.error("Error removing notification token:", error);

        // Clear localStorage
        localStorage.clear();
        // Redirect to login page and refresh the window
        navigate("/login");
        window.location.reload();
      }
    } else {
      // Clear localStorage
      localStorage.clear();
      // Redirect to login page and refresh the window
      navigate("/login");

      window.location.reload();
    }
  };

  const fetchProfileData = async () => {
    try {
      const res = await ProfileDetails(currentUser?.uuid);
      setProfileData(res.data);
      localStorage.setItem("manualToggle", "false");
      // Accessing the chef plan subscription and its accesses
      const plan_name = res.data?.chef_plan_subscriptions?.[0]?.plan;
      setIsPlanName(plan_name); // Set state with is_coupon value
      const chefPlanAccess =
        res.data?.chef_plan_subscriptions?.[0]?.plan?.chef_plan_accesses?.[0];
      
      
      
      
      // Check if chefPlanAccess exists before setting state
      if (chefPlanAccess) {
        setIsCoupon(chefPlanAccess.is_coupon); // Set state with is_coupon value
        setIsReport(chefPlanAccess.is_report); // Set state with is_coupon value
      }
      // Setting other state variables
      setChefStatus(res.data?.currentlyAvailableStatus);
      
      setnotificationSound(res.data?.notification_master?.tone);
    } catch (error) {
      console.error("Error fetching profile details:", error);
    }
  };
  const fetchSettings = async () => {
    try {
      const res = await settingsDetails(1);
      setSettings(res.data);
    } catch (error) {
      console.error("Error fetching Settings details:", error);
    }
  };
  useEffect(() => {
    fetchProfileData();
    fetchSettings();
  }, []);

  const showNotification = () => {
    setShowModel(true);
    // playNotificationSound();
  };

  const handleClose = () => {
    setShowModel(false);
    clearNotification(chefId).then((res: any) => {
      setNotification(res);
    });
  };

  useEffect(() => {
    
    const storedStatus = localStorage.getItem("chefStatus");
    
    if (storedStatus !== null) {
      setChefStatus(JSON.parse(storedStatus));
    }

    // Function to fetch order details and update state
    const fetchOrderDetails = () => {
      listOrdersData(chefId).then((res: any) => {
        // Extract orderId from the order object
        const orderId = res?.orderId;
        // Set orderId state
        setOrderId(orderId);
        setOrders(res);
      });
      // getNotification(chefId).then((res: any) => {

      //   setNotification(res);
      // });
    };
    // Initial call
    fetchOrderDetails();
    // Set up interval to fetch order details every 30 seconds
    // const intervalId = setInterval(fetchOrderDetails, 30000);
    // // Clean up interval on component unmount
    // return () => clearInterval(intervalId);
  }, []);

  const handleChefStatusChange = async () => {
    const newStatus = !chefStatus;
    
    // --- TIME VALIDATION ---
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const openingTime = settings?.opening_time;
    const closingTime = settings?.closing_time;
    const [openH, openM] = openingTime.split(":").map(Number);
    const [closeH, closeM] = closingTime.split(":").map(Number);

    const openingMinutes = openH * 60 + openM;
    const closingMinutes = closeH * 60 + closeM;
    // 7AM = 7, 9PM = 21
    if (
      newStatus === true &&
      (currentMinutes < openingMinutes || currentMinutes >= closingMinutes)
    ) {
      toast.warning(
        `Heads up! You can go Online only between ${formatToAMPM(
          openingTime
        )} and ${formatToAMPM(closingTime)}`
      );
      return; // Stop execution
    }

    if (!currentUser?.address?.address) {
      navigate("/settings/no-address-found", { replace: true });
      return; // Prevent further execution
    }
    if (!chefId) {
      toast.error("Chef ID is missing. Unable to update status.");
      return;
    }

    const data = {
      chefId,
      status: newStatus,
    };

    if (!socket.connected) {
      try {
        socket.connect(); // Ensure it's connected before emitting events
      } catch (error) {
        console.error("Socket connection failed:", error);
        toast.error("Failed to connect to the server. Please try again.");
        return;
      }
    }

    // Emit the update to the backend through socket
    socket.emit("changeChefStatus", data, (res: any) => {
      if (!res) {
        toast.error("No response from the server. Please try again.");
        return;
      }

      //
      if (res?.status == true) {
        toast.success(
          newStatus
            ? "Online Status Confirmed – Happy Cooking!"
            : "Currently Offline – We'll Be Back Soon.."
        );
        localStorage.setItem("chefStatus", JSON.stringify(newStatus));
        setChefStatus(newStatus);
        setManualToggle(!newStatus); // true if offline
        // navigate("/dashboard");
      } else {
        toast.error(res.message || "Failed to update status.");
      }
    });
  };

  // useEffect(() => {
  //   handleChefStatusChange();
  // }, []);

  const [isLeftBarActive, setLeftBarActive] = useState(false);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setLeftBarActive(!isLeftBarActive);
    document.body.classList.add("overflow-hidden");
  };

  const handleMenuBackdropClick = () => {
    // Remove the active classes
    setLeftBarActive(false);
    document.body.classList.remove("overflow-hidden");
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (!currentUser?.address?.address) {
      event.preventDefault();
      navigate("/settings/no-address-found", { replace: true }); // 🚀 Redirect user
    }
    setLeftBarActive(false);
    document.body.classList.remove("overflow-hidden");
  };

  const clickMainSearch = async (e: any) => {
    e.preventDefault();
    const searchTerm = mainSearch;

    setLoading(true);

    try {
      const res = await searching(chefId, searchTerm);
      setLoading(false);

      // Check the type of search result
      if (res?.success === true) {
        toast.success(res?.message, { autoClose: 5000 });
      } else {
        toast.error(res?.message, { autoClose: 5000 });
      }

      let destination = "";

      if (res?.data?.type === "dish") {
        destination = `/dish/list?search=${encodeURIComponent(searchTerm)}`;
      } else if (res?.data?.type === "orders") {
        destination = `/orders/history?search=${encodeURIComponent(
          searchTerm
        )}`;
      } else if (res?.data?.type === "coupon") {
        destination = `/coupon/list?search=${encodeURIComponent(searchTerm)}`;
      } else if (res?.data?.type === "addons") {
        destination = `/addons/list?search=${encodeURIComponent(searchTerm)}`;
      } else {
        // destination = `/dish?search=${encodeURIComponent(searchTerm)}`;
        navigate("/");
      }
      // Navigate to the destination, even if it's the same route
      navigate(destination, { replace: true });
    } catch (error) {
      console.error("Error fetching coupon:", error);
      setLoading(false);
    }
  };

  const clearSearch = () => {
    setMainSearch(""); // Clear the search term
    localStorage.removeItem("mainSearch"); // Remove the search term from localStorage
    navigate("/dish/list"); // Navigate to the dish list without any search parameter
  };

  const handleOrderStatusChange = async (
    order: OrderProps,
    action: string,
    reason?: string
  ) => {
    try {
      
      let newOrderStatusId: number;
      let orderMessage: string;

      switch (action) {
        case "Accept Order":
          newOrderStatusId = 3;
          orderMessage = "has been accepted";
          break;
        case "Cancel Order":
          newOrderStatusId = 7;
          orderMessage = reason
            ? `has been canceled due to: ${reason}`
            : "has been canceled";
          
          break;
        default:
          console.warn("Unknown action:", action);
          return;
      }

      const data = {
        status: newOrderStatusId,
        userId: order.userId,
        orderId: order.uuid,
        uuid: order.uuid,
        chefId,
        ...(action === "Cancel Order" && {
          reason: reason?.trim() || "No reason provided",
        }),
      };

      

      socket.emit("updateOrderStatus", data, async (res: any) => {
        if (res?.status === true) {
          toast.success(`Order ${order.orderId} ${orderMessage} successfully`, {
            autoClose: 5000,
          });

          stopNotificationSound();

          const updatedOrders = await listOrdersData(currentUser?.uuid);
          setOrders(updatedOrders);

          const pendingOrders = updatedOrders.filter(
            (ord: OrderProps) => ord.orderstatusId === 1
          );

          if (pendingOrders.length === 0) {
            setShowOrderModal(false);
            navigate("/orders/view");
          }

          if (action === "Accept Order") {
            
            setTimeout(() => {
              toast.info(
                `Order ${order.orderId}  being prepared. A confirmation will be sent after 1 hour. )`,
                {
                  autoClose: 7000,
                }
              );
            }, 1000);
          }
        } else {
          toast.error(res?.message, { autoClose: 5000 });
        }
      });
    } catch (error) {
      console.error("Error handling order status change:", error);
    }
  };

  useEffect(() => {
    const hasPendingOrder = orders?.some((o) => o.orderstatusId === 1);

    if (hasPendingOrder && msgsound) {
      playNotificationSound();
    } else {
      stopNotificationSound();
    }
  }, [orders, msgsound]);

const playNotificationSound = () => {
  if (!msgsound) return;

  // Ensure no duplicate playing
  stopNotificationSound();

  const audio = new Audio(msgsound);
  audioRef.current = audio;

  let playCount = 0;
  const maxPlays = 10;
  const playDuration = 3000;
  const gapDuration = 10000;

  const schedulePlay = () => {
    if (!audioRef.current) return;
    if (playCount >= maxPlays) return;

    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(console.error);

    playCount++;

    const stopId = window.setTimeout(() => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    }, playDuration);
    soundTimeoutsRef.current.push(stopId);

    const nextId = window.setTimeout(
      schedulePlay,
      playDuration + gapDuration
    );
    soundTimeoutsRef.current.push(nextId);
  };

  schedulePlay();
};


const stopNotificationSound = () => {
  // Stop audio immediately
  if (audioRef.current) {
    try {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    } catch {}
    audioRef.current = null;
  }

  // Clear all play loops
  soundTimeoutsRef.current.forEach((id) => clearTimeout(id));
  soundTimeoutsRef.current = [];
};


  const handleNavigation = (isAccessGranted: any, path: any) => {
    if (!isAccessGranted) {
      // Show toast notification for restricted access
      // toast.error("You don't have access to this feature. Please upgrade your plan.");
      navigate("/access");
    } else {
      navigate(path); // Navigate only if access is granted
    }
  };
  const { workingHours, updateWorkingHours } = useWorkingHours();
  // Ref to store timeouts for working hours
  const timeoutsRef = useRef<NodeJS.Timeout[]>([]);

  useEffect(() => {
    listTiming(chefId).then((res) => {
      
      const normalized = normalizeWorkingHours(res.data);
      updateWorkingHours(normalized);
    });
  }, [chefId]);
useEffect(() => {
  return () => {
    stopNotificationSound();
  };
}, []);

  return (
    <>
      <Sidebar
        isLeftBarActive={isLeftBarActive}
        handleMenuItemClick={handleMenuItemClick}
        getIsCoupon={getIsCoupon}
        getIsReport={getIsReport}
        handleNavigation={handleNavigation}
        ProfileDetails={ProfileDetails}
      />
      <HeaderMenu
        mainSearch={mainSearch}
        setMainSearch={setMainSearch}
        clearSearch={clearSearch}
        clickMainSearch={clickMainSearch}
        handleIconClick={handleIconClick}
        isVideoVisible={isVideoVisible}
        planName={planName}
        chefStatus={chefStatus}
        handleChefStatusChange={handleChefStatusChange}
        showNotification={showNotification}
        profiledata={profiledata}
        logoutFunction={logoutFunction}
        handleClick={handleClick}
        isLeftBarActive={false} // Adjust based on logic
        handleMenuBackdropClick={handleMenuBackdropClick}
      />

      <NotificationModal
        showModal={showModal}
        notification={notification}
        handleClose={handleClose}
      />

      <OrderModal
        showOrderModal={showOrderModal}
        order={orders}
        handleOrderStatusChange={handleOrderStatusChange}
        stopNotificationSound={stopNotificationSound}
      />
    </>
  );
};
export default Header;
